import { render, staticRenderFns } from "./channelSkuTab.vue?vue&type=template&id=cc636626&"
import script from "./channelSkuTab.vue?vue&type=script&lang=ts&"
export * from "./channelSkuTab.vue?vue&type=script&lang=ts&"
import style0 from "./channelSkuTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports